import { render, staticRenderFns } from "./SharingDialogComponent.vue?vue&type=template&id=25a46bfc&scoped=true&"
import script from "./SharingDialogComponent.vue?vue&type=script&lang=js&"
export * from "./SharingDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./SharingDialogComponent.vue?vue&type=style&index=0&id=25a46bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a46bfc",
  null
  
)

export default component.exports